"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileMultiLinks = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ConditionalLink_1 = require("Views/Shared/Components/ConditionalLink");
const TileMultiLinks = ({ multipleLinks, clickHandler }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: multipleLinks && multipleLinks.length !== 0 && ((0, jsx_runtime_1.jsx)("ul", { className: "gap-md mt-sm flex", children: multipleLinks.map(link => {
                if (link && link.url) {
                    return ((0, jsx_runtime_1.jsx)("li", { className: "flex items-center", children: (0, jsx_runtime_1.jsx)(ConditionalLink_1.ConditionalLink, { className: "link-primary", link: link, onClick: clickHandler, children: link.caption }, link.caption) }, link.caption));
                }
            }) })) }));
};
exports.TileMultiLinks = TileMultiLinks;
